<app-view-stack class="report-views" [viewName]="reportMode">
  <app-view-stack-view viewName="costs"><app-report-costs #costReport
      [route]="route"></app-report-costs></app-view-stack-view>
  <app-view-stack-view viewName="supplemental"><app-report-supplemental
      #supplReport></app-report-supplemental></app-view-stack-view>
  <app-view-stack-view viewName="summary"><app-report-summary #summaryReport
      [route]="route" (tallyChange)="SetTally($event)"></app-report-summary></app-view-stack-view>
</app-view-stack>
